// Redesigned Footer.jsx
import React from 'react';
import BrandIcon from './BrandIcon';
import Button from '../elements/Button';

export default function Footer() {
  return (
    <footer className="bg-[#1e1e2e] text-white py-12">
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between">
        <div className="md:w-1/3 mb-6 md:mb-0">
          <BrandIcon />
          <p className="mt-4 text-gray-300">
            De consultancy die klaarstaat voor zijn klanten
          </p>
        </div>

        <div className="md:w-1/3 mb-6 md:mb-0">
          <h2 className="text-xl font-bold mb-4">Contact</h2>
          <p className="text-gray-300">stijn@galacticautomation.com</p>
          <p className="text-gray-300">+32 477 967 741</p>
        </div>

        <div className="md:w-1/3">
          <h2 className="text-xl font-bold mb-4">Volg ons</h2>
          <Button
            href="https://www.linkedin.com/company/galacticautomation"
            type="link"
            target="_blank"
            className="text-gray-300 hover:text-gray-400 underline transition"
            isExternal
          >
            LinkedIn
          </Button>
        </div>
      </div>
      <div className="text-center text-gray-400 mt-8 border-t border-gray-700 pt-4">
        © 2025 Galactic Automation – Alle rechten voorbehouden.
      </div>
    </footer>
  );
}
